import * as React from 'react';
import { History } from 'history';
import '../styles.css';
import { FormattedMessage } from 'react-intl';
import img from '../../images/contact-us-1908762_1920.png';

interface IProps {
    history: History;
}

export default (props: IProps) => {
    return (
        <section className="contact-section py-5">
            <div className="container text-center">

                <img src={img} alt="Harmonize office" className="img-fluid mb-4 main-image" />

                <address className="contact-info">
                    <h2 className="mb-3">
                        <a href="mailto:info@myharmonize.com" className="text-decoration-none">
                            info@myharmonize.com
                        </a>
                    </h2>

                    <h2 className="mb-3">
                        <a href="tel:3055350914" className="text-decoration-none">
                            305.535.0914
                        </a>
                    </h2>

                    <h2 className="mb-0">
                        1313&nbsp;Ponce&nbsp;de&nbsp;Leon&nbsp;Blvd.<br />
                        Suite&nbsp;301<br />
                        Coral&nbsp;Gables,&nbsp;FL&nbsp;33134
                    </h2>
                </address>
            </div>
        </section>

)
}


// WEBPACK FOOTER //
// ./src/public/contact/index.tsx